/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Iki_FaktorluInputs */

const tr_faq_q_iki_faktorlu = /** @type {(inputs: Faq_Q_Iki_FaktorluInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İki adımlı doğrulama (2FA) var mı?`)
};

const en_faq_q_iki_faktorlu = /** @type {(inputs: Faq_Q_Iki_FaktorluInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is two-factor authentication (2FA) available?`)
};

const de_faq_q_iki_faktorlu = /** @type {(inputs: Faq_Q_Iki_FaktorluInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gibt es eine Zwei-Faktor-Authentifizierung (2FA)?`)
};

const ru_faq_q_iki_faktorlu = /** @type {(inputs: Faq_Q_Iki_FaktorluInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Есть ли двухфакторная аутентификация (2FA)?`)
};

/**
* | output |
* | --- |
* | "Is two-factor authentication (2FA) available?" |
*
* @param {Faq_Q_Iki_FaktorluInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_iki_faktorlu = /** @type {((inputs?: Faq_Q_Iki_FaktorluInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Iki_FaktorluInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_iki_faktorlu(inputs)
	if (locale === "de") return de_faq_q_iki_faktorlu(inputs)
	if (locale === "ru") return ru_faq_q_iki_faktorlu(inputs)
	return tr_faq_q_iki_faktorlu(inputs)
});